export default __webpack_public_path__ + "static/media/emptyMsgIcon.804a8325.png";